/**
 * I18nProvider — wrapper fino sobre `I18nextProvider` do react-i18next.
 *
 * Importa `./index` pelo seu efeito colateral (inicialização do i18n) e
 * expõe a instância via contexto, para que `useTranslation()` funcione
 * em qualquer componente da árvore.
 *
 * Uso (em `src/app.tsx`):
 *   <I18nProvider>
 *     <App />
 *   </I18nProvider>
 */
import type { ReactNode } from 'react'
import { I18nextProvider } from 'react-i18next'

import i18n from './index'

interface I18nProviderProps {
  children: ReactNode
}

export function I18nProvider({ children }: I18nProviderProps): JSX.Element {
  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>
}

export default I18nProvider
